import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ShareLinkForm from '../../components/share-link-form';
import { closeModal } from '../../actions/close-modal';

const ShareLinkModal = ({ closeModal, url }) =>
  <Modal onClose={closeModal}>
    <ShareLinkForm url={url} onCancel={closeModal}/>
  </Modal>;

ShareLinkModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  t: PropTypes.func,
};

const mapDispatchToProps = {
  closeModal,
};

export default connect(undefined, mapDispatchToProps)(ShareLinkModal);



// WEBPACK FOOTER //
// ./app/containers/share-link-modal/share-link-modal.js